export default function DownloadIcon() {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.5 15C3.5 17.8284 3.5 19.2426 4.37868 20.1213C5.25736 21 6.67157 21 9.5 21H15.5C18.3284 21 19.7426 21 20.6213 20.1213C21.5 19.2426 21.5 17.8284 21.5 15"
        stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.5 3V16M12.5 16L16.5 11.625M12.5 16L8.5 11.625" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
